import { all } from 'redux-saga/effects';

import preferredSiteSaga from './preferred-site-saga';

export default function* rootSaga() {
  yield all([preferredSiteSaga()]);
}
